import script from "./ContactInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ContactInfo.vue?vue&type=style&index=0&id=a5206118&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5206118"]])

export default __exports__